/**
 * This file contains field error messages that are reused across the app.
 * Some guidance when adding messages to this file:
 * - Use the field label exactly including casing.
 * - Messages should be terse
 */
export const ERROR_MESSAGES = {
  REQUIRED: 'Required',
  INVALID_DATE: 'Invalid date',
  POSITIVE_INT: 'Must be greater than 0',
  NON_NEGATIVE_INT: 'Cannot be negative',
  WHOLE_NUMBER: 'Must be a whole number',
  FUTURE_DATE: 'Date must be current or in the past',
  PAST_DATE: 'Date must be current or in the future',
  INVALID_ZIP_CODE: 'Invalid zip code',
  INVALID_START_END_DATES: '"Start Date" must be before "End Date"',
  INVALID_DATE_ORDER: (startDateLabel: string, endDateLabel: string) =>
    `"${startDateLabel}" must be before "${endDateLabel}"`,
  INVALID_NUMBER_RANGE: (minLabel: string, maxLabel: string) =>
    `"${minLabel}" must be less than or equal to "${maxLabel}"`,
  MAX_CHARACTER_LIMIT: (charLimit: number) => `Must be ${charLimit} or less characters`,
  MIN_CHARACTER_LIMIT: (charLimit: number) => `Must be at least ${charLimit} characters`,
  EXACT_CHARACTER_LIMIT: (charLimit: number) => `Must be exactly ${charLimit} characters`,
};
